import { render, staticRenderFns } from "./shop_detial.vue?vue&type=template&id=1eb545d6&scoped=true"
import script from "./shop_detial.vue?vue&type=script&lang=js"
export * from "./shop_detial.vue?vue&type=script&lang=js"
import style0 from "./shop_detial.vue?vue&type=style&index=0&id=1eb545d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb545d6",
  null
  
)

export default component.exports